import { render, staticRenderFns } from "./QuestionsContext.vue?vue&type=template&id=a92f56b4&scoped=true&"
import script from "./QuestionsContext.vue?vue&type=script&lang=js&"
export * from "./QuestionsContext.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsContext.vue?vue&type=style&index=0&id=a92f56b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92f56b4",
  null
  
)

export default component.exports